import { createContext, ReactNode, useContext } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Context = createContext<any>(null);

export function DynamicAttributeFieldInputProps<T>({
  children,
  ...rest
}: T & {
  children: ReactNode;
}) {
  return <Context.Provider value={rest}>{children}</Context.Provider>;
}

export function useInputProps() {
  return useContext(Context);
}
